<template>
  <div class="play-list">
    <el-row :gutter="28" class="course-list" v-if="courseList.length > 0">
      <el-col
        :span="6"
        class="course-item-wrapper"
        v-for="item in courseList"
        :key="item.id"
      >
        <div class="item-wrapper" @click="goCourse(item)">
          <course-item :courseItem="item"></course-item>
        </div>
      </el-col>
    </el-row>
    <no-result v-else tips="暂无相关信息"></no-result>
  </div>
</template>

<script>
import dataMsg from "mock/data.json";
import CourseItem from "@/components/course-item/course-item";
import NoResult from "@/components/no-result/no-result";
export default {
  props: {
    courseList: {
      type: Array,
      default: function() {
        return dataMsg.myCourseAll16;
      }
    }
  },
  components: {
    CourseItem,
    NoResult
  },
  methods: {
    goCourse(item) {
      if (item.hasOwnProperty("linkType") && item.linkType === 1) {
        window.open(item.linkUrl, "_blank");
        return;
      }
      // let routeData = this.$router.resolve({path: '/CourseDetails', query: item})
      let routeData = this.$router.resolve({
        path: "/CourseDetails",
        query: { id: item.id, orgInfoId: item.orgInfoId }
      });
      window.open(routeData.href, "_self");
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
// @import "../../common/less/variable";
@import "~@/styles/base.scss";
.play-list {
  .course-list {
    // height: 480px;
    // background-color: pink;
    .course-item-wrapper {
      margin-top: 20px;
      height: 240px;
      &:hover {
        transition: all 0.3s;
        transform: translate3d(0, -5px, 0);
      }
      .item-wrapper {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course-classify/components/course-list.vue